import React from 'react';
import OptionMultiSelect from './OptionMultiSelect';
import { useSuppliers } from './supplierApiHelpers';

/**
 * Searchable multi-select for sellers. Stores supplier `seller_id` values
 * (the backend payload field is still `seller_ids`) and shows `company_name`
 * as the label. Any previously-saved ids that no longer exist in the fetched
 * list are preserved so legacy rules remain editable.
 */
const SellerMultiSelect = ({
  label = 'Sellers',
  placeholder = 'Search sellers...',
  values = [],
  onChange,
}) => {
  const { suppliers, loading, error } = useSuppliers();

  return (
    <OptionMultiSelect
      label={label}
      placeholder={placeholder}
      options={suppliers}
      values={values}
      onChange={onChange}
      loading={loading}
      error={error}
      emptyText="No sellers found"
      loadingText="Loading sellers..."
      errorText="Failed to load sellers. Showing previously saved values only."
    />
  );
};

export default SellerMultiSelect;
